// src/components/TemplateSelector.tsx
import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { TemplateData } from '../types/Template.ts';

interface TemplateSelectorProps {
  templates: TemplateData[];
  onChange: (templateId: string | undefined) => void;
  value?: string;
}

const TemplateSelector: React.FC<TemplateSelectorProps> = ({ templates, onChange, value }) => {
  const [selected, setSelected] = useState<string | undefined>(value);

  useEffect(() => {
    onChange(selected);
  }, [selected, onChange]);

  return (
    <Select
      placeholder="テンプレートを選択"
      style={{ width: '100%' }}
      value={selected}
      onChange={(val) => setSelected(val)}
      allowClear
    >
      {templates.map((t) => (
        <Select.Option key={t.id} value={t.id}>
          {t.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default TemplateSelector;
